import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import { Input } from "components/shared/input";
import style from "./contact-me-form.module.scss";
import { ContactFormField } from "store/url-builder";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";

const schema = yup.object().shape({
  "Full Name": yup.string().required(),
  "Email Adress": yup.string().email().required(),
  "Phone Number": yup.string().required(),
  "Company Name": yup.string(),
  "Job Title": yup.string(),
  Message: yup.string().required(),
});

const useStyles = makeStyles({
  root: (props: any) => ({
    "& label.Mui-focused": {
      color: props.color,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: props.color,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: props.color,
      },
      "&:hover fieldset": {
        borderColor: props.color,
      },
      "&.Mui-focused fieldset": {
        borderColor: props.color,
      },
    },
  }),
});

export interface ContactMeFormProps {
  color?: string;
  fileds: ContactFormField[];
  userId: string;
  userAgent?: string;
  cardId?: number;
}

export const ContactMeForm = ({
  color,
  fileds,
  userId,
  userAgent,
  cardId,
}: ContactMeFormProps) => {
  const classes = useStyles({ color });
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const RenderField = useCallback(
    (field: ContactFormField) => {
      switch (field.fieldType) {
        case "Textarea":
          return (
            <>
              <Typography variant="subtitle2">{field.fieldName}</Typography>
              <Controller
                control={control}
                name={field.fieldName}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    className={classes.root}
                    onChange={onChange}
                    value={value}
                    error={!!errors[field.fieldName]}
                    helperText={errors[field.fieldName]?.message}
                    multiline
                    rows={6}
                    fullWidth
                  />
                )}
              />
            </>
          );
        default:
          return (
            <Controller
              control={control}
              name={field.fieldName}
              render={({ field: { onChange, value } }) => (
                <Input
                  className={classes.root}
                  label={field.fieldName}
                  onChange={onChange}
                  value={value}
                  error={!!errors[field.fieldName]}
                  helperText={errors[field.fieldName]?.message}
                  fullWidth
                />
              )}
            />
          );
      }
    },
    [classes, errors, control]
  );

  const submit = (data: any) => {
    setIsSubmitting(true);

    var fullName = data["Full Name"];
    var namesArray = fullName.split(" ");

    var firstName = "";
    var lastName = "";
    var title = data["Job Title"]?.trim() || " ";
    var companyName = data["Company Name"]?.trim() || " ";
    var phoneNumber = data["Phone Number"];
    var message = data["Message"];
    var email = data["Email Adress"];

    firstName = namesArray[0];

    if (namesArray.length == 1) {
      lastName = firstName;
    } else {
      for (var nCnt = 1; nCnt < namesArray.length; nCnt++) {
        lastName += namesArray[nCnt] + " ";
      }
      lastName = lastName.trim();
    }

    var sendee_id = Buffer.from(userId).toString("base64");

    var sendingData = {
      function: "send_generic_card",
      parameters: {
        submitData: {
          first_name: firstName,
          last_name: lastName,
          job_title: title,
          company_name: companyName,
          email: email,
          phone: phoneNumber,
          message: message,
          sendee_id: sendee_id,
          userAgent: userAgent
            ? userAgent
            : "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/101.0.4951.67 Safari/537.36",
          cardId,
        },
        option_data: {
          17: title,
          18: firstName,
          19: lastName,
          20: phoneNumber,
          21: email,
          33: companyName,
        },
      },
      token: "",
    };

    axios({
      method: "post",
      url: "/pro/client",
      data: sendingData,
      headers: { "Content-Type": "application/json" },
    })
      .then(function (response) {
        //handle success
        console.log(response);
        toast.success("The message is sent");
        reset({
          "Full Name": "",
          "Email Adress": "",
          "Phone Number": "",
          "Company Name": "",
          "Job Title": "",
          Message: "",
        });
        setIsSubmitting(false);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
        toast.error("An error occured");
        setIsSubmitting(false);
      });
  };

  return (
    <form className={style.root} onSubmit={handleSubmit(submit)}>
      <Grid container spacing={2}>
        {fileds.map((field, idx) => (
          <Grid item xs={12} key={idx}>
            {RenderField(field)}
          </Grid>
        ))}
        <Grid item xs={12}>
          <Button
            style={{ backgroundColor: color, color: "#fff" }}
            className={roundedButtonStyle.root}
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending Message..." : "Send Message"}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
